import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

// Basic selectors
export const selectNotifications = (state: RootState) => state.ui.notifications
export const selectModals = (state: RootState) => state.ui.modals
export const selectSidebarCollapsed = (state: RootState) => state.ui.sidebarCollapsed
export const selectTheme = (state: RootState) => state.ui.theme
export const selectStaffViewMode = (state: RootState) => state.ui.staffViewMode
export const selectIsStaffUserView = createSelector(
    [selectStaffViewMode],
    (mode) => mode === 'user'
)
export const selectIsRefreshing = (state: RootState) => state.ui.isRefreshing

// Notification selectors
export const selectHasNotifications = createSelector(
    [selectNotifications],
    (notifications) => notifications.length > 0
)

export const selectNotificationCount = createSelector(
    [selectNotifications],
    (notifications) => notifications.length
)

export const selectErrorNotifications = createSelector(
    [selectNotifications],
    (notifications) => notifications.filter(n => n.type === 'error')
)

export const selectSuccessNotifications = createSelector(
    [selectNotifications],
    (notifications) => notifications.filter(n => n.type === 'success')
)

// Modal selectors
export const selectIsTableDetailModalOpen = createSelector(
    [selectModals],
    (modals) => modals.tableDetail.isOpen
)

export const selectTableDetailModalTableId = createSelector(
    [selectModals],
    (modals) => modals.tableDetail.tableId
)

export const selectTableDetailOpenStartForm = createSelector(
    [selectModals],
    (modals) => modals.tableDetail.openStartForm
)

export const selectTableDetailInitialPlayers = createSelector(
    [selectModals],
    (modals) => modals.tableDetail.initialPlayers
)

export const selectIsStartTableModalOpen = createSelector(
    [selectModals],
    (modals) => modals.startTable.isOpen
)

export const selectStartTableModalTableId = createSelector(
    [selectModals],
    (modals) => modals.startTable.tableId
)

export const selectIsUserSearchModalOpen = createSelector(
    [selectModals],
    (modals) => modals.userSearch.isOpen
)

export const selectIsTariffEditModalOpen = createSelector(
    [selectModals],
    (modals) => modals.tariffEdit.isOpen
)

export const selectTariffEditModalTariffId = createSelector(
    [selectModals],
    (modals) => modals.tariffEdit.tariffId
)

export const selectAnyModalOpen = createSelector(
    [selectModals],
    (modals) => Object.values(modals).some(modal => modal.isOpen)
)

// Theme selectors
export const selectIsDarkMode = createSelector(
    [selectTheme],
    (theme) => theme === 'dark'
)

export const selectIsLightMode = createSelector(
    [selectTheme],
    (theme) => theme === 'light'
)